import React from "react";

// adds extra disabled option for dropdowns
export function getOptions(options, placeholderText) {
  return [
    {
      value: "",
      text: placeholderText,
      disabled: true,
    },
    ...options,
  ];
}

// fiters out skills for a dropdown that are selected in other dropdowns
export function getFilteredSkills(
  skills,
  firstSkillToFilter,
  secondSkillTFilter
) {
  return skills.filter(
    (skill) =>
      !(
        skill.value === firstSkillToFilter || skill.value === secondSkillTFilter
      )
  );
}
// Styled placeholder with red *
export const CustomPlaceholder = ({ text }) => (
    <span>
        {text} <span style={{ color: "red" }}>*</span>
    </span>
);

// Function to map options for React Select
export const getReactSelectOptions = (options) =>
    options.map((opt) => ({ value: opt.value, label: opt.text }));



// generates options for months of experience dropdown
export function getMonthsOfExperience() {
  const months = [];
  for (let i = 1; i <= 11; i++) {
    months.push({
      value: String(i),
      text: String(i),
    });
  }
  return months;
}

const isSmallScreen = window.innerWidth < 600;

export const customStyles = {
    container: (base) => ({
        ...base,
        width: isSmallScreen ? "100%" : "426px",
        marginLeft: isSmallScreen ? "0" : "8px",
        marginRight: isSmallScreen ? "0" : "8px",
        marginBottom: isSmallScreen? "4.8px" : "0",
        marginTop: "4.8px",
    }),
    control: (base) => ({
        ...base,
        height: "40px",
        minHeight: "40px",
        border: "1px solid grey",
        borderRadius: "2px",
    }),
};

// generates options for years of experience dropdown
export function getYearsOfExperience() {
  const years = [];
  for (let i = 1; i <= 25; i++) {
    years.push({
      value: String(i),
      text: String(i),
    });
  }
  return years;
}

// returns the date for "n" years ago. used for min and max date values in react date picker
export function getDateNYearsAgo(n) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - n);
  return date;
}
export function getDateNMonthsAgo(n) {
  const date = new Date();
  date.setMonth(date.getMonth() - n);
  return date;
}

// returns true/false based on whether there are too many digits after the decimal place in a number
export function tooManyDigitsAfterDecimal(num) {
  const text = num.toString();
  const index = text.indexOf(".");
  return index === -1 || text.length - index - 1 <= 2 ? false : true;
}

// creates string representation for a date object
export function getDateString(dateObject) {
  if (dateObject === "" || dateObject === null) {
    return "";
  }
  let date = dateObject.getDate();
  date = date >= 10 ? String(date) : String(`0${date}`);

  // month values are from 0-11
  let month = dateObject.getMonth() + 1;
  month = month >= 10 ? String(month) : String(`0${month}`);

  const year = dateObject.getFullYear();

  return `${year}-${month}-${date}`;
}

// constants for form validation
export const maxYearOfCompletion = new Date().getFullYear();
export const minYearOfCompletion = 1970;

export const minScore = 0;
export const maxScore = 100;
export const stepScore = 0.01;

export const minCTC = 0;
export const stepCTC = 0.01;

// Getting online status from navigator object

const getOnLineStatus = () =>
  typeof navigator !== "undefined" && typeof navigator.onLine === "boolean"
    ? navigator.onLine
    : true;

// Getting online status of the User

export const useNavigatorOnLine = () => {
  const [status, setStatus] = React.useState(getOnLineStatus());

  const setOnline = () => setStatus(true);
  const setOffline = () => setStatus(false);

  React.useEffect(() => {
    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);

    return () => {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);

  return status;
};

const CAREERS_REFERRAL_KEY = "careersRef";
const CAREERS_REFERRAL_MAX_AGE_MS = 10000;
const CAREERS_AUTHORIZED_KEY = "careersAuthorized";

// call before navigating to /apply from within the careers site, so /apply can tell a real referral from a directly opened link
export const markCareersReferral = () => {
  sessionStorage.setItem(CAREERS_REFERRAL_KEY, Date.now());
};

// checked on /apply mount; consumes the flag set by markCareersReferral and falls back to document.referrer as a secondary signal.
// once authorized, "careersAuthorized" is kept for the rest of the tab's life so a mid-form refresh doesn't re-trigger the notice
export const isReferredFromCareersPage = () => {
  if (sessionStorage.getItem(CAREERS_AUTHORIZED_KEY) === "true") {
    return true;
  }

  const referredAt = sessionStorage.getItem(CAREERS_REFERRAL_KEY);
  sessionStorage.removeItem(CAREERS_REFERRAL_KEY);

  if (referredAt && Date.now() - Number(referredAt) <= CAREERS_REFERRAL_MAX_AGE_MS) {
    sessionStorage.setItem(CAREERS_AUTHORIZED_KEY, "true");
    return true;
  }

  if (document.referrer.startsWith(window.location.origin)) {
    sessionStorage.setItem(CAREERS_AUTHORIZED_KEY, "true");
    return true;
  }

  return false;
};
